export default __webpack_public_path__ + "static/media/handlePullRequests.0569c0e0.png";